import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_memu_tree = _resolveComponent("memu-tree")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("div", {
    style: {"position":"relative"},
    class: _normalizeClass(_ctx.collapsed ? 'menu-slide' : ''),
    onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showArrow = true)),
    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showArrow = false))
  }, [
    _createVNode(_component_a_menu, {
      class: _normalizeClass(["custom-menu mtbox", _ctx.collapsed ? 'menu-slide' : '']),
      mode: "inline",
      openKeys: _ctx.openKeys,
      "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.openKeys) = $event)),
      selectedKeys: _ctx.selectedKeys,
      "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedKeys) = $event)),
      onSelect: _ctx.selectItem,
      "inline-collapsed": _ctx.collapsed
    }, {
      default: _withCtx(() => [
        _createVNode(_component_memu_tree, {
          menuList: _ctx.menu,
          onHandleClick: _ctx.handleClick,
          distanceIndex: 1,
          collapsed: _ctx.collapsed
        }, null, 8, ["menuList", "onHandleClick", "collapsed"])
      ]),
      _: 1
    }, 8, ["class", "openKeys", "selectedKeys", "onSelect", "inline-collapsed"])
  ], 34))
}